import { httpCall, httpMethod } from "../../service";
import { showlog } from "../../utils";

export async function getCompanies() {
	try {
		return await httpCall(httpMethod.GET, `mobileagent/company-list`)
	} catch (e) {
		showlog("errore in getCompanies()", e);
		return [];
	}
}

export async function getCompaniesDetailsAsync(names: string[]) {
	try {
		const body = {
			names: names
		}
		return httpCall(httpMethod.POST, `mobileagent/company-details`, body)

	} catch (e) {
		throw e;
	}
}
